import { useState } from "react";

const AnalyticalToolsContentSix = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "What are The Pips Analytical Tools?",
      text: `They are a suite of advanced market analysis tools designed to help traders make data-informed decisions through real-time insights and trend visualization.`,
    },
    {
      title: "Do I need an account to access them?",
      text: `Yes, you’ll need a free The Pips account to unlock full access to all features.`,
    },
    {
      title: "Are the tools suitable for beginners?",
      text: `Absolutely. Each tool comes with a user-friendly interface and guides to help traders of any level interpret data confidently.`,
    },
    {
      title: "Can I use these tools on mobile devices?",
      text: `Yes, all analytical tools are fully compatible with iOS and Android devices for seamless on-the-go trading.`,
    },
    {
      title: "How often is the data updated?",
      text: `Our systems refresh market data in real time to ensure complete accuracy and reliability.`,
    },
    {
      title: "Are these tools free to use?",
      text: `Most analytical tools are available free of charge for registered users.`,
    },
    // {
    //   title: "What markets do these tools cover?",
    //   text: `They support analysis across forex, commodities, indices, cryptocurrencies, and stocks.`,
    // },
  ];

  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row">
          {/* LEFT SIDE IMAGE + TEXT */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Driven by Insight. Designed for You.</h2>
              <p>
                Our mission is to simplify market complexity through innovation.
                Every analytical tool we build is guided by real trader
                feedback, ensuring accuracy, usability, and an experience that
                truly adds value to your trading journey.
              </p>
            </div>
            <div className="thumb-left">
              <img
                src={process.env.PUBLIC_URL + "/images/resources/analytical_tools/analytical_tools_4.png"}
                alt="computer images"
              />
            </div>
          </div>

          {/* RIGHT SIDE ACCORDION */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <hr className="black-line" />
              {sections.map((section, index) => (
                <div key={index} className="accordion-section">
                  <button
                    className="accordion-header"
                    onClick={() => toggleSection(index)}
                  >
                    <h3>{section.title}</h3>
                    <span
                      className={`arrow ${openIndex === index ? "open" : ""}`}
                    >
                      ▼
                    </span>
                  </button>

                  <div
                    className={`accordion-content ${
                      openIndex === index ? "show" : ""
                    }`}
                  >
                    <p>{section.text}</p>
                  </div>

                  <hr className="black-line" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticalToolsContentSix;
